import { ReactNode, useContext } from 'react';
import { Portal } from '../components/Portal';
import { OverlayContext } from './context';

interface OverlayPortalProps {
  children: ReactNode
}

export function OverlayPortal({ children }: OverlayPortalProps) {
  const { getElement } = useContext(OverlayContext);

  const overlayElement = getElement();

  return <Portal container={overlayElement}>{children}</Portal>;
}
